import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Chip from 'Chip';
import ChipEdit from 'ChipEdit';
import chipDataTransform from 'chipDataTransform';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
import Nav from './nav';
import Article from './article';
import Recommend from './recommend';
import GoodArticle from './goodArticle';
import GoodAudio from './goodAudio';
// import GoodVideo from './goodVideo';
// import FengUser from './fengUser';
// import Weixin from './weixin';
// import Welfare from './welfare';
// import Wireless from './wireless';
// import PerfectBook from './perfectBook';
import BottomFooter from './bottomFooter';
import Ad from '@ifeng-fe/ui_pc_ad';

const Layout = ({ content }) => {
    useEffect(() => {}, []);

    const recommendData = {
        isHitBlack: content.isHitBlack,
        relatedRecommend: content.relatedRecommend,
        isCloseAlgRec: content.isCloseAlgRec,
        base62Id: content?.article?.base62Id || '',
        ad: content.feedAd,
    };

    return (
        <>
            {/* <Chip id="260661" type="struct" title="导航" groupName="导航" content={content.navList}>
                <Nav />
            </Chip> */}
            <div className={styles.navBox} />
            <div className={styles.contentBox}>
                <div className={styles.contentLeft}>
                    <Article content={content.docData} />
                    <Ad content={content.leftRectAd} />
                    <Recommend content={recommendData} />
                    <GoodAudio content={content.goodAudio} title="精品有声" />
                    <GoodAudio content={content.goodBook} title="好书精选" />
                </div>
                <div className={styles.contentRight}>
                    <GoodArticle />
                    <div className={styles.rightRectAd}>
                        <Ad content={content.rightRectAd} />
                    </div>
                    {/* <GoodVideo />
                    <FengUser content={content.assess} />
                    <Weixin content={content.qrCodeSet} />
                    <Welfare content={content.welfare} />
                    <Welfare content={content.fhhQrcode} />
                    <Wireless />
                    <PerfectBook content={content.perfectBook} /> */}
                </div>
            </div>
            <BottomFooter content={{ footer: content.footer }} />
            <ChipEdit transform={chipDataTransform} />
        </>
    );
};

Layout.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(Layout);
